import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Top2: FC<IconSvgProps> = ({ clss, width = 25, height = 25, hideText }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12.1327" cy="12.1327" r="11.6327" fill="url(#paint0_linear_top2)" stroke="url(#paint1_linear_top2)" />
            {!hideText && (
                <path
                    d="M15.5571 15.8875V17.2035H9.28509L12.5191 13.2835C12.8411 12.8915 13.3311 12.2755 13.6391 11.8275C13.9051 11.4355 14.1291 11.0295 14.1291 10.4835C14.1291 9.69949 13.6111 8.97149 12.5751 8.97149C11.5251 8.97149 10.9791 9.78349 10.9231 10.6655H9.55109C9.59309 9.75549 9.97109 9.02749 10.3351 8.62149C10.6711 8.24349 11.3431 7.71149 12.5191 7.71149C14.5071 7.71149 15.5291 9.06949 15.5291 10.5255C15.5291 11.2955 15.2351 11.9255 14.8571 12.4855C14.5211 12.9895 14.0871 13.5075 13.5271 14.1655L12.0711 15.8875H15.5571Z"
                    fill="#000D44"
                    fillOpacity="0.1"
                />
            )}
            <defs>
                <linearGradient id="paint0_linear_top2" x1="12.1327" y1="3.65668" x2="33.2572" y2="16.506" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#CCCCCC" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint1_linear_top2" x1="24.2336" y1="28.5898" x2="1" y2="-0.694114" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#CCCCCC" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default Top2;
